import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import apiClient from "../../Services/apiClient";
import { useNavigate } from "react-router-dom";



function GroupPage() {
  const { groupId } = useParams();
  const [data, setData] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [formData, setFormData] = useState({});
const navigate = useNavigate();
  useEffect(() => {
    if (!groupId) return;

    const token = localStorage.getItem("token");

    apiClient
      .get(`services/group/${groupId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setData(res.data))
      .catch((err) => console.error(err));
  }, [groupId]);

  const handleApply = async (serviceId) => {
    navigate(`/service/${serviceId}/apply`);
  };

  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const formPayload = new FormData();

      Object.keys(formData).forEach((key) => {
        formPayload.append(key, formData[key]);
      });

      await apiClient.post(
        `services/${selectedService.id}/apply`,
        formPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Application submitted successfully!");
      setSelectedService(null);
      setFormData({});
    } catch (err) {
      console.error(err);
      alert("Failed to submit application.");
    }
  };

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">All Services</li>
                  </ol>
                </div>
                <h4 className="page-title">Services</h4>
              </div>
            </div>
          </div>

          {/* Services List */}
          {data.length > 0 ? (
            data.map((category) => (
              <div key={category.categoryId} className="row mb-4">
                <div className="col-12">
                  <h4 className="mb-3 border-bottom pb-2">
                    {category.categoryName}
                  </h4>
                </div>

                {category.services.map((service) => (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6"
                    key={service.id}
                  >
                    <div className="card">
                      <div className="card-body text-center">
                        <h5 className="card-title">{service.name}</h5>
                        <div className="d-grid">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => handleApply(service.id)}
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div className="row">
              <div className="col-12">
                <p>No services available.</p>
              </div>
            </div>
          )}

          {/* Dynamic Form */}
          {selectedService && (
            <div className="row mt-5">
              <div className="col-12">
                <h4>Apply for: {selectedService.name}</h4>
                <form onSubmit={handleSubmit}>
                  {selectedService.formSchema.map((field) => (
                    <div className="mb-3" key={field.id}>
                      <label className="form-label">{field.label}</label>
                      {field.type === "textarea" ? (
                        <textarea
                          className="form-control"
                          name={field.id}
                          value={formData[field.id]}
                          onChange={handleInputChange}
                          placeholder={field.placeholder || ""}
                          required={field.required}
                        />
                      ) : field.type === "file" ? (
                        <input
                          type="file"
                          className="form-control"
                          name={field.id}
                          onChange={handleInputChange}
                          required={field.required}
                        />
                      ) : (
                        <input
                          type={field.type}
                          className="form-control"
                          name={field.id}
                          value={formData[field.id]}
                          onChange={handleInputChange}
                          placeholder={field.placeholder || ""}
                          required={field.required}
                        />
                      )}
                    </div>
                  ))}

                  <button type="submit" className="btn btn-success">
                    Submit Application
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => setSelectedService(null)}
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default GroupPage;
